import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../../store"
import OldUIContext from "../../../olduicontext"

import LogoutPage from "./components/LogoutPage"
import { IOldUIContext } from "../../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): void {
    const element = document.getElementById("newui-logout")

    if (!element) {
        return // we're not on the logout page, no need to init the logout sub app
    }
    const root = createRoot(element)
    root.render(
        <Provider store={store}>
            <OldUIContext.Provider value={oldUIContext}>
                <LogoutPage />
            </OldUIContext.Provider>
        </Provider>,
    )
}

export default init
